import dayjs from "dayjs";

interface IProps {
    data: ITicketCheckData
    style?: React.CSSProperties
}

interface ITicketCheckData {
    programTitle: string
    programIsPaid: boolean
    qrcodeImgUrl: string
    memberName: string
    targetDateTime: string
    ticketTotalCount: number
    ticketName?: string
}

const TicketCheckCard = ({ data, style }: IProps) => {
    return <>
        <div style={{ margin: '0', textAlign: 'center', width: 'calc(100% - 20px)', ...style }}>
            <div className="sub-title/st5 base/white" style={{ marginBottom: '32px' }}>
                {data.programTitle}
                {data.programIsPaid &&
                    <div className="sub-title/st2 base/white">
                        {data.ticketName}
                    </div>}
            </div>
            <div style={{ paddingInline: '47.5px', marginBottom: '32px' }}>
                <img width={'100%'} style={{ maxWidth: 240, borderRadius: 'var(--radius4)' }} src={data.qrcodeImgUrl} />
            </div>
            <div className="sub-title/st5 base/white" style={{ marginBottom: '8px' }}>
                {data.memberName}
            </div>
            <div className="sub-title/st2 base/white" style={{ marginBottom: '8px' }}>
                {dayjs(data.targetDateTime).format('YYYY.MM.DD (ddd) HH:mm')}
            </div>
            <div className="sub-title/st2 base/white">
                {data.ticketTotalCount}명
            </div>
        </div>
    </>
}
export default TicketCheckCard;